import React, { useState } from "react";
import {
  canOpenAttachmentInApp,
  downloadNoteAttachment,
} from "../../utils/noteAttachments";
import NoteAttachmentPreviewModal from "./NoteAttachmentPreviewModal";

function NoteAttachmentDownloadButton({
  attachment,
  className = "my-notes-view-attachment-btn",
}) {
  const [busy, setBusy] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const canPreview = canOpenAttachmentInApp(attachment);

  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (busy) {
      return;
    }

    if (canPreview) {
      setPreviewOpen(true);
      return;
    }

    setBusy(true);
    try {
      await downloadNoteAttachment(attachment);
    } catch (error) {
      console.error("Failed to download attachment", error);
      window.alert("Could not download this file. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const buttonLabel = canPreview
    ? busy
      ? "Opening..."
      : <img src="../assets/images/attach-file.png" alt="Download" width={15} height={15} />
    : busy
      ? "Downloading..."
      : "Download attachment";

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={handleClick}
        disabled={busy}
        title={attachment.fileName}
      >
        {buttonLabel}
      </button>

      {previewOpen ? (
        <NoteAttachmentPreviewModal
          attachment={attachment}
          onClose={() => setPreviewOpen(false)}
        />
      ) : null}
    </>
  );
}

export default NoteAttachmentDownloadButton;
